<template>
  <header class="nav-bar">
    <RouterLink class="brand" to="/market" aria-label="UniBridge">
      <img src="@/assets/navigation/logo.png" alt="UniBridge" />
    </RouterLink>
    <nav :class="['nav-links', { open: menuOpen }]">
      <RouterLink :to="{ name: 'marketCollections' }" @click="menuOpen = false">
        {{ $t('market.title') }}
      </RouterLink>
      <RouterLink :to="{ name: 'FAQ' }" @click="menuOpen = false">
        {{ $t('FAQ.title') }}
      </RouterLink>
      <a :href="blogUrl" @click="menuOpen = false">{{ $t('blog.title') }}</a>
      <a href="https://docs.unibridge.io/" target="_blank" rel="noreferrer">
        {{ $t('navBar.DOC') }}
      </a>
    </nav>
    <div class="language-picker">
      <button type="button" @click="toggleLanguage">{{ languageLabel }}</button>
    </div>
    <button
      class="menu-button"
      type="button"
      :aria-expanded="menuOpen"
      aria-label="Toggle navigation"
      @click="menuOpen = !menuOpen"
    >
      <img src="@/assets/home/navMenu.png" alt="" />
    </button>
  </header>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
const menuOpen = ref(false);
const blogUrl = process.env.BASE_URL + 'blog/';
const languageLabel = computed(() => locale.value === 'zh_TW' ? '繁中' : 'EN');

const toggleLanguage = () => {
  locale.value = locale.value === 'zh_TW' ? 'en_US' : 'zh_TW';
};
</script>

<style scoped lang="less">
.nav-bar {
  position: relative;
  z-index: 10;
  display: flex;
  width: 90%;
  min-height: 9rem;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
}
.brand img {
  display: block;
  width: 16.9rem;
  height: 6.2rem;
  object-fit: contain;
}
.nav-links {
  display: flex;
  align-items: center;
  gap: 2.2rem;
  a {
    color: #0f2d44;
    font-size: 1.7rem;
    text-decoration: none;
    transition: color 0.2s;
    &:hover {
      color: #566ffe;
    }
  }
}
.language-picker button,
.menu-button {
  border: 0;
  background: transparent;
  color: #0f2d44;
  cursor: pointer;
  font-size: 1.5rem;
}
.menu-button {
  display: none;
  img {
    width: 3rem;
    height: 3rem;
  }
}
@media screen and (max-width: 750px) {
  .nav-bar {
    width: 100%;
    min-height: 7rem;
    padding: 0 2rem;
    background: #fff;
  }
  .brand img {
    width: 10.13rem;
    height: 3.6rem;
  }
  .menu-button {
    display: block;
    margin-left: 1.5rem;
    padding: 0;
  }
  .language-picker {
    margin-left: auto;
  }
  .nav-links {
    position: absolute;
    top: 6.5rem;
    right: 1rem;
    display: none;
    min-width: 18rem;
    padding: 1.5rem;
    border-radius: 1rem;
    background: #fff;
    box-shadow: 0 4px 18px rgb(15 45 68 / 15%);
    align-items: flex-start;
    flex-direction: column;
    gap: 1.2rem;
    &.open {
      display: flex;
    }
  }
}
</style>
